<template>
  <div class="settings">
    <div class="settings--title fs-25 black--text font-weight-medium">
      Settings
    </div>
    <div class="settings-body mt-5">
      <div class="profileSettings">
        <v-card elevation="4" class="px-6 my-8 py-4">
          <ProfileSettings />
        </v-card>
      </div>
      <div class="accountSettings">
        <v-card elevation="4" class="px-6 py-4">
          <AccountSettings />
        </v-card>
      </div>
      <div class="timePeriod mt-8">
        <v-card elevation="4" class="px-6 py-4">
          <TimePeriod />
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import TimePeriod from "@/modules/DashboardModule/components/settings/TimePeriod";
import AccountSettings from "@/modules/DashboardModule/components/settings/AccountSettings";
import ProfileSettings from "@/modules/DashboardModule/components/settings/ProfileSettings";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "Settings",
  components: {
    TimePeriod,
    AccountSettings,
    ProfileSettings
  },
  mixins: [commonMethodsMixin]
};
</script>
